import { Trans, useTranslation } from 'next-i18next'

import Toast, { ToastBody, ToastBold } from '../../../../shared/Toast'

const DeleteTracksToast = ({
	tracks,
	projectName,
	error = false,
}: {
	tracks: Track[]
	projectName: string
	error?: boolean
}): JSX.Element => {
	const { t } = useTranslation(['projectedit'])
	const translationKey =
		tracks.length > 1
			? 'delete-tracks-toast.multi-track-success-message'
			: 'delete-tracks-toast.single-track-success-message'

	if (error) {
		const errorMessage =
			tracks.length > 1
				? t('delete-tracks-toast.multi-track-error-message')
				: t('delete-tracks-toast.single-track-error-message')
		return (
			<Toast>
				<ToastBody>{errorMessage}</ToastBody>
			</Toast>
		)
	}

	return (
		<Toast>
			<ToastBody>
				<Trans components={{ bold: <ToastBold /> }}>
					{t(translationKey, {
						trackCount: tracks.length,
						projectName,
					})}
				</Trans>
			</ToastBody>
		</Toast>
	)
}

export default DeleteTracksToast
